import { render } from "./record_dint_come.svg.vue?vue&type=template&id=6fb8e62a"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__